export default class BookletAffiSignature {
    constructor() {
        console.log("BookletAffiSignature initialized");
        this.has_signed = false;
        if($("#yousign-iframe").length>0) {
            this.check_status_link = $("#yousign-iframe").data("statusLink");
            this.initializeYousign();
        }else{
            console.error("Yousign iframe not found");
        }
    }

    initializeYousign() {
        if (typeof Yousign !== 'undefined') {
            this.yousign = new Yousign({
                signatureLink: $("#yousign-iframe").data("externalLink"),
                iframeContainerId: 'yousign-iframe',
                //isSandbox: true,
            });
            this.bindEvents();
        } else {
            this.loadYousignScript(() => {
                this.yousign = new Yousign({
                    signatureLink: $("#yousign-iframe").data("externalLink"),
                    iframeContainerId: 'yousign-iframe',
                    //isSandbox: true,
                });
                this.bindEvents();
            });
        }
    }

    loadYousignScript(callback) {
        // Check if script is already loading or loaded
        if (document.querySelector('script[src*="iframe-sdk"]')) {
            // Script is already present, wait for it to load
            const checkYousign = () => {
                if (typeof Yousign !== 'undefined') {
                    callback();
                } else {
                    setTimeout(checkYousign, 100);
                }
            };
            checkYousign();
            return;
        }

        const script = document.createElement('script');
        script.src = 'https://cdn.yousign.tech/iframe-sdk-1.6.0.min.js';
        script.integrity = 'sha384-/7MD1voOOzWVz7FmgeMwmmd1DO85Mo0PkkxdYd9j2wDGzGDGRG/phgnL0c9Xyy52';
        script.crossOrigin = 'anonymous';
        script.onload = callback;
        document.head.appendChild(script);
    }

    bindEvents() {
        var self = this;
        
        window.addEventListener('resize', () => {
            self.resizeIframe();
        });
        this.yousign.onStarted((data) => {
            console.log("Signer has opened the signature");
            console.log(data);
        });
          
        this.yousign.onSuccess((data) => {
            console.log("Signer has successfully signed");
            self.has_signed = true;
            self.checkStatus();
            console.log(data);
        });
          
        this.yousign.onError((data) => {
            console.log("Signer encountered an error when signing");
            console.log(data);
        });
          
        this.yousign.onPing((data) => {
            console.log("Ping - The signature request is loaded");
            console.log(data);
            // Hide loader and show iframe when the signature request is loaded
            self.hideLoader();
        });
          
        this.yousign.onDeclined((data) => {
            console.log("Declined - The signer declined the signature");
            console.log(data);
        });

        this.resizeIframe();
    }

    hideLoader() {
        $('#iframe-loader').addClass('d-none');
        $("#affi-content-wrapper").addClass('p-0');
        $('#yousign-iframe').show();
    }

    checkStatus() {
        console.log("checkStatus called -> "+this.has_signed);
        console.log(this.check_status_link);
        //Ajax request to this.check_status_link
        if(this.has_signed) {
        
            $.ajax({
                url: this.check_status_link,
                method: "GET"
            }).done((response) => {
                console.log("checkStatus response -> "+response.success);
                if(response.success == true) {
                    console.log("Signature status updated successfully");
                    //redirect to the affi page
                    window.location.href = response.redirect_url;
                }
                else {
                    setTimeout(() => {
                        this.checkStatus();
                    }, 2000);
                }
            }).fail((error) => {
                console.error("Error updating signature status", error);
            });
        }
    }

    resizeIframe() {
        const iframe = document.getElementById('yousign-iframe');
        const viewportHeight = window.innerHeight;
        iframe.style.height = (viewportHeight - 220) + 'px';
    }
}